import { DanceManagerFeatureNameEnum } from '../enums';

export interface UpdateDanceManagerFeatureInterface {
  features: DanceManagerFeatureNameEnum[];
}
